import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
const Crop = (props) => (
  <Icon viewBox="0 0 14 14" {...props}>
    <g>
      <path d="M10.5 10.5H4.812A1.314 1.314 0 0 1 3.5 9.187V3.5h5.688c1.312 0 1.312.659 1.312.875V10.5zm.875 0V4.375c0-1.095-.818-1.75-2.188-1.75H3.5V0h-.875v2.625H0V3.5h2.625v5.688a2.19 2.19 0 0 0 2.188 2.187H10.5V14h.875v-2.625H14V10.5h-2.625z"
        fillRule="evenodd" />
    </g>
  </Icon>
);
/*eslint-enable */

export default Crop;



// WEBPACK FOOTER //
// ./~/wix-style-react/src/Icons/dist/components/Crop.js